import PropTypes from 'prop-types';

import Badge from 'shopper/components/Badge';
import Flex from 'shopper/components/Flex';

import { hasHighlightBadge, hasVerifiedBadge } from 'lib/offer';

import OFFER from 'constants/offer';

const OfferBadges = ({ offerIsHighlight, offerStatusName }) => (
  <Flex flexWrap="wrap" mb={[null, null, 2]}>
    {hasVerifiedBadge(offerStatusName) && (
      <Badge type="info" mr={2} mb={2}>
        {OFFER.BADGES.VERIFIED}
      </Badge>
    )}
    {offerStatusName === OFFER.STATUSES.TOP_OFFER && (
      <Badge type="spotlight" mr={2} mb={2}>
        {OFFER.BADGES.LOWEST_PRICE}
      </Badge>
    )}
    {hasHighlightBadge(offerIsHighlight, offerStatusName) && (
      <Badge type="primary" mr={2} mb={2}>
        {OFFER.BADGES.FEATURED}
      </Badge>
    )}
    {offerStatusName === OFFER.STATUSES.FINISHED && (
      <Badge type="default" mr={2} mb={2}>
        {OFFER.BADGES.FINISHED_OFFER}
      </Badge>
    )}
  </Flex>
);

OfferBadges.defaultProps = {
  offerIsHighlight: null,
  offerStatusName: null,
};

OfferBadges.propTypes = {
  offerIsHighlight: PropTypes.bool,
  offerStatusName: PropTypes.string,
};

export default OfferBadges;
